import {
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSLoader,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { useClientQuery } from "../../../query/users/queries";
import { selectorCreditCardName } from "../../selectors/selectorCreditCardName";
import { BankCardLogo } from "../BankCardLogo";
import { selectorPaymentMethod } from "./selectorPaymentMethod";

type Props = {
  type: "credit";
  cardId: string;
} & WSElementProps;

export const BankCard: React.FC<Props> = ({ cardId, ...elementProps }) => {
  const userId = useUserId();
  const queryClient = useClientQuery(userId);

  if (!queryClient.data) {
    return (
      <WSElement {...elementProps}>
        <WSLoader.Spinner />
      </WSElement>
    );
  }

  const creditCard = selectorPaymentMethod(queryClient.data, cardId);

  return (
    <WSElement {...elementProps}>
      <WSFlexBox.CenterY wrap="nowrap" justify="space-between">
        <WSFlexBox.CenterY wrap="nowrap" gap="S">
          <BankCardLogo.Circle type="credit" brand={creditCard?.cardBrand} />
          <WSText kind="ParagraphSm" weight="medium">
            {selectorCreditCardName(creditCard)}
          </WSText>
        </WSFlexBox.CenterY>
      </WSFlexBox.CenterY>
    </WSElement>
  );
};
